import { Expose, Type } from "../../serialization/class-transformer/decorators";
import { AvailableLayoutDto } from "./available-layout-dto";

export class AvailableLayoutsInfoDto {

    constructor() {
        this.availableLayouts = [];
    }

    @Expose()
    @Type(() => AvailableLayoutDto)
    availableLayouts: AvailableLayoutDto[];

}

